module.exports = __webpack_public_path__ + "img/elite-hospital.c317efb7.png";